import { ContentSectionWithIcon } from '@cinch-labs/design-system'
import { storyblokEditable } from '@cinch-nx/data-storyblok'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'

import type { ContentWithIconsSection as ContentWithIconProps } from '../../types/our-commitment-page'
import styles from './content-with-icon.module.css'

export const ContentWithIcon: React.FC<ContentWithIconProps> = (blok) => {
  const { contentWithIcon } = blok

  return (
    <section
      {...storyblokEditable(blok)}
      className={styles.container}
      data-testid="content-with-icon"
    >
      {contentWithIcon.map((item) => (
        <ContentSectionWithIcon
          key={item.title}
          iconName={item.iconName}
          iconGradient="galaxy"
          title={item.title}
        >
          {renderWithResolver(item.body)}
        </ContentSectionWithIcon>
      ))}
    </section>
  )
}
